import _objectSpread from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.object.to-string.js";
import i18nInquiry from '../i18n-inquiry';
import i18nOrderDetail from '../../i18n-orderDetail';
import { getErpRequsstPriceNotifyList } from "@/services/order/inquiry";
export default {
  name: 'inquiryDetailInfo',
  i18n: {
    messages: {
      CN: _objectSpread(_objectSpread({}, i18nInquiry.messages.CN), i18nOrderDetail.messages.CN),
      JP: _objectSpread(_objectSpread({}, i18nInquiry.messages.JP), i18nOrderDetail.messages.JP)
    }
  },
  props: {
    quoteData: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  computed: {
    columns: function columns() {
      return [
      // 发送人    
      {
        title: this.$t("inquiryList.sender"),
        dataIndex: 'sendUserName',
        width: 150
      },
      // 发送时间
      {
        title: this.$t("inquiryList.sendTime"),
        dataIndex: 'sendTimeStr',
        width: 150
      },
      // 版本号
      {
        title: this.$t("inquiryList.sendVersion"),
        dataIndex: 'version',
        width: 150
      }];
    }
  },
  data: function data() {
    return {
      notifyList: [],
      isTableLoading: false
    };
  },
  mounted: function mounted() {
    this.quoteId = this.$route.query.id;
    this.loadBasicInfo();
  },
  methods: {
    loadBasicInfo: function loadBasicInfo() {
      var _this = this;
      this.isTableLoading = true;
      getErpRequsstPriceNotifyList(this.quoteId).then(function (response) {
        if (response.data.code == 200) {
          _this.notifyList = response.data.data;
          // this.orderInfo.BasicInfo = response.data.data.getInfosMainVo;
          // this.orderNoteList = response.data.data.getInfosChildVoList;
          // this.orderInfo.orderNoteList = response.data.data.getInfosChildVoList;
        }
      }).finally(function () {
        _this.isTableLoading = false;
      });
    }
  }
};